import { getUniqueId } from "basis";
import { PAGES } from "./constants";
import { Action, ActionType, State } from "./types";

export const emptyFormValues: State["formValues"] = {
  firstName: "",
  lastName: "",
  dateOfBirth: {
    day: "",
    month: "",
    year: "",
  },
  mobileNumber: "",
  relationship: "",
  products1: false,
  products2: false,
  products3: false,
  action: "",
  authorityLevel: "",
  other: "",
  accounts: {
    [getUniqueId()]: "",
  },
  organisationOrFinancialCounsellor: "",
  removalType: "",
  dateOfBirth2: {
    day: "",
    month: "",
    year: "",
  },
  addingPoaGuardianOrAdministrator: false,
  contactNumber: "",
  contactName: "",
  address: "",
  suburb: "",
  state: "",
  postcode: "",
  email: "",
  nominatedFullName: "",
  organisationOrFinancialCounsellorsName: "",
  primaryContact: "",
};

export const initialState: State = {
  page: PAGES.FORM,
  formValues: emptyFormValues,
};

export const reducer = (state: State, action: Action): State => {
  switch (state.page) {
    case PAGES.FORM: {
      switch (action.type) {
        case ActionType.ACCOUNT_INFO_LOADED: {
          return { ...state, accountInfo: action.accountInfo };
        }
        case ActionType.FORM_SUBMITTED: {
          return {
            ...state,
            page: PAGES.SUCCESS,
          };
        }

        default: {
          return state;
        }
      }
    }

    default: {
      return state;
    }
  }
};
